import React from "react";

import { AddRounded, MenuRounded } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import useAuth from "../../config/context/authContext";
import useMainState from "../../config/context/mainStateContext";
import useModal from "../../config/context/modalContext";
import { ChatService } from "../../config/services/ChatService";
import { Dev } from "../../config/util/consoleUtil";

import ChipMain from "../../components/InputMain/ChipMain";
import MainText from "../../components/MainText";
import PageHeader from "../../components/PageHeader";
import { UtilComponents } from "../../config/util/utilComponents";
import ChatItemComponent from "./components/ChatItemComponent";
import ModalCreateChat from "./components/ModalCreateChat";

export default function AccountChatsPage() {
  const { currentUserState, currentUserInfo } = useAuth();
  const navigate = useNavigate();

  const { pushAlert } = useModal();
  const { setShowSideMenuDrawer } = useMainState();

  const ChatListFromUser = ChatService.ListFromUser();
  const ChatListStaff = ChatService.ListAdmin();

  const [chatMode, setChatMode] = React.useState(
    UtilComponents.isStaff(currentUserState) ? "staff" : "user"
  );

  const [loadedChats, setLoadedChats] = React.useState<any[]>([]);

  const [showModalCreate, setShowModalCreate] = React.useState(false);

  const handleLoadChats = async () => {
    if (currentUserState) {
      if (chatMode === "staff") {
        const res = await ChatListStaff.runRequest().catch((err) => {
          console.log(...new Dev("ChatListStaff", err).Error());
          pushAlert({
            type: "error",
            message: "Erro ao listar conversas. " + (err as any).message,
          });
        });
        setLoadedChats(res as []);
      } else {
        const res = await ChatListFromUser.runRequest(currentUserState?.uid).catch((err) => {
          console.log(...new Dev("ChatListFromUser", err).Error());
          pushAlert({
            type: "error",
            message: "Erro ao listar conversas. " + (err as any).message,
          });
        });
        setLoadedChats(res as []);
      }
    }
  };

  const onCloseModalHandler = (reload?: boolean) => {
    setShowModalCreate(false);
    if (reload) handleLoadChats();
  };

  React.useEffect(() => {
    handleLoadChats();
  }, [chatMode]);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Chats"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
          rightIcon={UtilComponents.isStaff(currentUserState) ? <AddRounded /> : undefined}
          onRightAction={
            UtilComponents.isStaff(currentUserState) ? () => setShowModalCreate(true) : undefined
          }
        />

        {showModalCreate && <ModalCreateChat onClose={onCloseModalHandler} />}

        {UtilComponents.isStaff(currentUserState) && (
          <Box mb={2} gap={1} display={"flex"} flexWrap={"wrap"}>
            <ChipMain
              options={[
                { name: "Usuário", value: "user" },
                { name: "Staff", value: "staff" },
              ]}
              onChange={(value) => setChatMode(value as string)}
              value={chatMode}
            />
          </Box>
        )}

        <Box mb={2}>
          <MainText size="caption" color="regular">
            Essa funcionalidade ainda está sob desenvolvimento e pode conter bugs...
          </MainText>
        </Box>

        {ChatListFromUser.isLoading || ChatListStaff.isLoading ? (
          <>
            <Box mb={2}>
              <Skeleton
                animation="wave"
                variant="rounded"
                width={"100%"}
                height={100}
                sx={{ borderRadius: "15px", margin: "0px 4px" }}
              />
            </Box>
            <Box mb={2}>
              <Skeleton
                animation="wave"
                variant="rounded"
                width={"100%"}
                height={100}
                sx={{ borderRadius: "15px", margin: "0px 4px" }}
              />
            </Box>
          </>
        ) : (
          loadedChats?.map((item) => <ChatItemComponent key={item.id} chat={item} />)
        )}
      </Box>
    </Box>
  );
}
